import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Comune } from 'src/app/models/comune';
import { IncaricoService } from 'src/app/services/incarico.service';
import { Router } from '@angular/router'
//import {MarkerClusterer} from "@googlemaps/markerclusterer";

@Component({
  selector: 'mappa-sopralluoghi',
  templateUrl: './mappa-sopralluoghi.component.html',
  styleUrls: ['./mappa-sopralluoghi.component.scss']
})
export class MappaSopralluoghiComponent {
  search = {};
  comune: Comune;

  loading = false;

  constructor(private incaricoService: IncaricoService,
    private toast: ToastrService,
    private router: Router) { }

  async applySearch(search) {
    this.search = search;

    this.loading = true;
    this.comune = this.search["comune"];
    let res = await this.incaricoService.ricavaIncarichiDaCitta(this.comune);

    this.loading = false;

    if (res != null && Object.keys(res).length > 0) {
      this.initMap(res);
      // this.toast.success('Incarichi trovati: ' + Object.keys(res).length);
    } else {
      // this.toast.error('Nessun incarico trovato');
    }
  }

  map: any;
  async initMap(res): Promise<void> {
  /*  //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    //@ts-ignore
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    const bounds = new google.maps.LatLngBounds();

    res = Object.keys(res).map(key => ({id: key, lat: res[key].lat, lng: res[key].lng}))

    this.map = new Map(
      document.getElementById('map') as HTMLElement,
      {
        zoom: this.comune ? 13 : 5,
        center: this.comune ? {lat: +res[0].lat, lng: +res[0].lng} : {lat: 41.8719, lng: 12.5674}, // Comune come centro se !null, altrimenti Centro Italia
        mapId: '57fdfaf21844489e'
      }
    );

    let markers = res.map((element, i) => {
      let marker = new AdvancedMarkerElement({
        map: this.map,
        position: {lat: +element.lat, lng: +element.lng},
      })

      marker.addListener("click", () => {
        let url = this.router.serializeUrl(this.router.createUrlTree(['/incarichi/' + element.id]));
        window.open(url, '_blank');
      })
      bounds.extend(new google.maps.LatLng(+element.lat, +element.lng));
      return marker;
    });
    new MarkerClusterer({ markers, map: this.map });
    this.map.fitBounds(bounds);
    */
  }
}
